const ES = {
    modal: {
        title: 'Subir archivo',
    },
    uploader: {
        title: 'Padrones',
        selectOrDrag: 'Seleccionar o arrastrar el archivo',
        subtitle: '.txt, peso inferior a 100MB',
        button: 'Seleccionar archivo',
        error: 'El archivo no pudo ser procesado',
    },
    states: {
        loading: 'Cargando...',
        success: 'El archivo fue procesado \n correctamente',
        error: 'El archivo \n no pudo ser procesado',
        warning: 'Solo se permiten archivos ".txt" \n y no superar los 100 MB de tamaño'
    },
    buttonMessage: {
        sircupaButtonMessage: 'Cargar padrón'
    }
};

export default ES;
